import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
body{
    margin:0;
    padding: 0;
background-color: rgba(221, 238, 252, 1);
font-family: Roboto Mono, monospace ;
}



`;
